import React from 'react';
import FadeIn from './FadeIn';

export default function Mission() {
  return (
    <section className="section-spacing relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1606787366850-de6330128bfc?auto=format&fit=crop&w=1920&q=80"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-white/90"></div>
      </div>

      <div className="content-width text-center relative z-10">
        <FadeIn>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground tracking-tight">
            Designed For Modern Households
          </h2>
        </FadeIn>
        <FadeIn delay={0.15}>
          <p className="mt-6 text-muted-foreground text-lg leading-relaxed max-w-lg mx-auto">
            One Click Essentials is built to simplify everyday grocery procurement. Our mission is to save time, reduce effort, and bring convenience to every household.
          </p>
        </FadeIn>
      </div>
    </section>
  );
}
